import { useLazyGetQuery } from "slices/api";

export const useLazyGetOverallComplianceCityWiseQuery = () => {
  const [complianceDetails, data] = useLazyGetQuery();
  const complianceDetail = async (query = {}) =>
    await complianceDetails(
      {
        endpoint: "/schedule/report/overallcompliance-city-level",
        query,
      },
      true
    ).unwrap();
  return [complianceDetail, data];
};

export const useLazyGetInspectionStatusQuery = () => {
  const [inspectionStatusDetails, data] = useLazyGetQuery();
  const inspectionStatus = async (query = {}) =>
    await inspectionStatusDetails(
      {
        endpoint: "/schedule/report/inspection-status",
        query,
      },
      true
    ).unwrap();
  return [inspectionStatus, data];
};

export const useLazyGetCommonInspectionObservationQuery = () => {
  const [commonInspectionDetails, data] = useLazyGetQuery();
  const commonInspections = async (query = {}) =>
    await commonInspectionDetails(
      {
        endpoint:
          "/inspection-observation/report/common-inspection-observation",
        query,
      },
      true
    ).unwrap();
  return [commonInspections, data];
};

export const useLazyGetComplianceRateOverTimeQuery = () => {
  const [complianceRateOverTimeDetails, data] = useLazyGetQuery();
  const complianceRateOverTime = async (query = {}) =>
    await complianceRateOverTimeDetails(
      {
        endpoint: "/schedule/report/compliance-rate-over-time",
        query,
      },
      true
    ).unwrap();
  return [complianceRateOverTime, data];
};

export const useLazyGetDeveloperBuildingComplianceQuery = () => {
  const [developerBuildingComplianceDetails, data] = useLazyGetQuery();
  const developerBuildingCompliance = async (query = {}) =>
    await developerBuildingComplianceDetails(
      {
        endpoint: "/developer-building/half-year",
        query,
      },
      true
    ).unwrap();
  return [developerBuildingCompliance, data];
};

export const useLazyGetInspectionObservationBuildingComplianceQuery = () => {
  const [inspectionObservationBuildingDetails, data] = useLazyGetQuery();
  const inspectionObservationBuildingCompliance = async (query = {}) =>
    await inspectionObservationBuildingDetails(
      {
        endpoint:
          "/inspection-observation/report/developer-building-compliance",
        query,
      },
      true
    ).unwrap();
  return [inspectionObservationBuildingCompliance, data];
};

export const useLazyGetNonComplianceCorrectiveActionQuery = () => {
  const [inspectionObservationBuildingDetails, data] = useLazyGetQuery();
  const inspectionObservationBuildingCompliance = async (query = {}) =>
    await inspectionObservationBuildingDetails(
      {
        endpoint:
          "/inspection-observation/report/non-compliance-corrective-action-status-building",
        query,
      },
      true
    ).unwrap();
  return [inspectionObservationBuildingCompliance, data];
};
